<template>
  <div id="header">
    <div class="header-logo">
      <img class="logo-image" src="../assets/images/logo/log.png" alt="" />
      <div class="logo-chunhua">
        <p style="font-size: 24px; color: #1E1E1E">春华健康</p>
        <p style="font-size: 14px; color: #1E1E1E">Chunhua Health</p>
      </div>
    </div>
    <el-menu
      style="background: #ffffff; border: none"
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      router
    >
      <el-menu-item index="home">{{ $t("lang.Home.name") }}</el-menu-item>
      <el-submenu index="1">
        <template slot="title"
          ><span style="font-size: 18px">{{
            $t("lang.ServiceItems.name")
          }}</span></template
        >
        <el-menu-item index="BestMedicalCare">{{
          $t("lang.BetterMedicalCare.name")
        }}</el-menu-item>
        <!--<el-menu-item index="internationalReferral">{{
          $t("lang.InternationalReferral.name")
        }}</el-menu-item>-->
        <!--<el-menu-item index="internationalReferral">蓝十医旅</el-menu-item>-->
        <el-menu-item index="BlueCross">蓝十医旅</el-menu-item>
        <el-menu-item index="KangBao">康保通</el-menu-item>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title"
          ><span style="font-size: 18px">{{
            $t("lang.InformationCenter.name")
          }}</span></template
        >
        <el-menu-item index="ServeCase">{{
          $t("lang.ServiceCase.name")
        }}</el-menu-item>
        <el-menu-item index="information">{{
          $t("lang.NewsInformation.name")
        }}</el-menu-item>
      </el-submenu>
      <el-menu-item index="about">{{ $t("lang.About.name") }}</el-menu-item>
      <el-menu-item index="recruit">{{ $t("lang.Recruit.name") }}</el-menu-item>
    </el-menu>
    <div class="wechatLogin">
      <div class="head-portrait">
        <img v-if="!logStatus" src="../assets/images/wechat.png" alt="" />
        <img v-else :src="user.headimgurl || src" alt="" />
      </div>
      <div class="login">
        <p v-if="!logStatus" @click="getQrcode">微信登录</p>
        <p v-else class="user-name">
          {{ user.nickname }}
          <el-tooltip
            class="item"
            effect="light"
            content="退出登录"
            placement="right"
          >
            <span class="iconfont" @click="logUot">&#xe619;</span>
          </el-tooltip>
        </p>
      </div>
    </div>
    <div class="language">
      <div class="language-item" @click="handleChineseClick">
        <p>
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-zhongguo-"></use>
          </svg>
        </p>
        <p class="content">Chinese</p>
      </div>
      <div class="language-item" @click="handleEnglishClick">
        <p>
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-meiguo-"></use>
          </svg>
        </p>
        <p class="content">English</p>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" class="qrcode">
      <h3 class="login-title">
        <span class="iconfont wechat-icon">&#xe625;</span>
        微信安全登录
      </h3>
      <div class="qrcode-img">
        <img :src="qrCode" alt="" />
      </div>
      <p class="sweep-code">微信扫描二维码登录</p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      fullscreenLoading: false, // 国际化loading
      logStatus: false,
      dialogVisible: false,
      user: {},
      qrCode: "",
      only: "",
      src: require("../assets/images/wechat.png")
    };
  },
  mounted() {
    if (sessionStorage.getItem("userInfo") && this.$store.state.logInStatus) {
      this.logStatus = this.$store.state.logInStatus;
      this.user = JSON.parse(sessionStorage.getItem("userInfo"));
    }
  },
  computed: {
    activeIndex() {
      return this.$route.path.replace("/", "");
    }
  },
  methods: {
    handleSelect() {},
    handleChineseClick() {
      // ourserve[5] homeCard[2]
      console.log(this.$options.parent);
      let that = this;
      if (that.$i18n.locale === "en-US") {
        that
          .$confirm("Switch Chinese, do you want to continue?", "Tips", {
            confirmButtonText: "confirm",
            cancelButtonText: "cancel",
            type: "warning"
          })
          .then(() => {
            this.fullscreenLoading = true;
            const loading = this.$loading({
              lock: true,
              text: "正在切换",
              spinner: "el-icon-loading",
              background: "rgba(255, 255, 255, 1.0)"
            });
            this.$store.dispatch("changeChinese", 1);
            // this.$options.parent.$children[5].$mount();
            setTimeout(() => {
              that.fullscreenLoading = false;
              that.$i18n.locale = "zh-CN";
              loading.close();
              that.$message({
                type: "success",
                message: "切换成功!"
              });
              this.$emit("update", 1);
            }, 1000);
          })
          .catch(err => {
            console.log(err);
            that.$message({
              type: "info",
              message: err
            });
          });
      }
    },
    handleEnglishClick() {
      let that = this;
      if (that.$i18n.locale === "zh-CN") {
        that
          .$confirm("切换为英文, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            this.fullscreenLoading = true;
            const loading = this.$loading({
              lock: true,
              text: "Switching",
              spinner: "el-icon-loading",
              background: "rgba(255, 255, 255, 1.0)"
            });
            this.$store.dispatch("changeEnglish", 1);
            // this.$options.parent.$children[5].$root.$options.render();
            setTimeout(() => {
              that.fullscreenLoading = false;
              that.$i18n.locale = "en-US";
              loading.close();
              that.$message({
                type: "success",
                message: "success!"
              });
              this.$emit("update", 1);
            }, 1000);
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "切换失败，请重试！"
            });
          });
      }
    },
    // 获取二维码
    getQrcode() {
      let that = this;
      if (!sessionStorage.getItem("userInfo")) {
        that.$http
          .post("http://api.chunhuahealth.com/api/qr_code/login")
          .then(res => {
            if (res.status === 200 && res.data.code === 20000) {
              console.log(res.data.data);
              that.qrCode = res.data.data;
              that.only = that.qrCode.split("_str=")[1]; // 登录用户唯一标识
              that.logIn();
            }
          });
      } else {
        that.user = JSON.parse(sessionStorage.getItem("userInfo"));
        sessionStorage.setItem("logInStatus", JSON.stringify(true));
        that.$store.dispatch(
          "changeLogInStatus",
          JSON.parse(sessionStorage.getItem("logInStatus"))
        );
        this.logStatus = this.$store.state.logInStatus;
        this.$message({
          type: "success",
          message: "登录成功!"
        });
      }
    },
    // 登录
    logIn: function() {
      this.dialogVisible = true;
      let that = this;
      let count = 0;
      let timer = setInterval(() => {
        that.$http
          .post("http://api.chunhuahealth.com/api/qr_code/verify", {
            qr_scene_str: that.only
          })
          .then(res => {
            console.log(res);
            if (res.status === 200 && res.data.code === 20000) {
              that.dialogVisible = false;
              this.$message({
                type: "success",
                message: "登录成功!"
              });
              console.log("登录成功");
              clearInterval(timer); // 停止计时器
              that.user = res.data.data; // 拿到用户信息
              sessionStorage.setItem("logInStatus", JSON.stringify(true)); // 存储用户登录状态到sessionStorage中
              that.$store.dispatch(
                "changeLogInStatus",
                JSON.parse(sessionStorage.getItem("logInStatus"))
              ); // 改变用户登录状态
              this.logStatus = this.$store.state.logInStatus;
              console.log(that.$store.state.logInStatus);
              sessionStorage.setItem("userInfo", JSON.stringify(res.data.data)); // 存储用户信息到sessionStorage中
            } else {
              console.log("等待用户扫码");
              count++;
            }
            if (count === 100 || !that.dialogVisible) {
              clearInterval(timer);
              that.dialogVisible = false;
            }
          });
      }, 3000);
    },
    // 退出登录
    logUot() {
      console.log("退出登录");
      this.$confirm("确定退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          sessionStorage.setItem("logInStatus", JSON.stringify(false));
          this.$store.dispatch(
            "changeLogInStatus",
            JSON.parse(sessionStorage.getItem("logInStatus"))
          );
          this.logStatus = this.$store.state.logInStatus;
          this.$message({
            type: "success",
            message: "退出成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/global";
#header {
  position: relative;
  display: flex;
  height: 150px;
  width: 100%;
  min-width: 1200px;
  background: #ffffff;
  .header-logo {
    margin-left: 50px;
    margin-top: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    .logo-image {
      margin-left: 20px;
      height: 49px;
      width: 58px;
    }
    .logo-chunhua {
      margin-left: 20px;
      p {
        margin-top: 8px;
      }
    }
  }
  .el-menu {
    margin-top: 80px;
    margin-left: 50px;
    .el-menu-item,
    .el-submenu {
      margin-left: 25px;
      font-size: 18px;
    }
  }
  .wechatLogin {
    position: absolute;
    left: 80%;
    bottom: 25px;
    display: flex;
    align-items: center;
    .head-portrait {
      height: 30px;
      width: 30px;
      border-radius: 50%;
      img {
        width: 100%;
        border-radius: 50%;
      }
    }
    .login {
      margin-left: 10px;
      font-size: 16px;
      color: #a4a4a4;
      cursor: pointer;
      .user-name {
        &:hover {
          color: #3496e3;
        }
      }
    }
  }
  .language {
    display: flex;
    position: absolute;
    bottom: 70px;
    left: 80%;
    .language-item {
      margin-right: 5px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .content {
        color: #a4a4a4;
      }
    }
  }
}
.icon {
  width: 2em;
  height: 2em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.qrcode {
  width: 800px;
  margin: 0 auto;
  .login-title {
    text-align: center;
    font-size: 20px;
    margin-bottom: 40px;
    .wechat-icon {
      color: #64ae43;
      font-size: 20px;
    }
  }
  .qrcode-img {
    width: 300px;
    height: 300px;
    margin: 0 auto;
    img {
      width: 100%;
      border: 1px solid #f1f5fe;
      border-radius: 10px;
    }
  }
  .sweep-code {
    margin: 20px;
    text-align: center;
    font-size: 16px;
    color: #c0c0c0;
  }
}
.el-dialog {
  border-radius: 20px;
}
</style>
